import sodium from "libsodium-wrappers";
import { compressSync, decompressSync } from "fflate";
import { unpack, pack } from "msgpackr";
import crypto from "./crypto";

/* ================================
   Buffer-level
================================ */
async function compressBuffer(input: any): Promise<Uint8Array> {
   await crypto.init();
   const encoded = pack(input);
   return compressSync(encoded);
}

async function decompressBuffer(input: Uint8Array): Promise<any> {
   await crypto.init();
   const decompressed = decompressSync(input);
   return unpack(decompressed);
}

/* ================================
   String-level
================================ */
async function compress(input: any): Promise<string> {
   await crypto.init();
   const compressed = await compressBuffer(input);
   return sodium.to_base64(
      compressed,
      sodium.base64_variants.ORIGINAL
   );
}

async function decompress(base64Str: string): Promise<any> {
   await crypto.init();
   const compressed = sodium.from_base64(
      base64Str,
      sodium.base64_variants.ORIGINAL
   );
   return decompressBuffer(compressed);
}

const compresor = {
   compressBuffer,
   decompressBuffer,
   compress,
   decompress
}

export default compresor